
import PropTypes from 'prop-types'
// import { useNavigate } from 'react-router-dom'
import { getAppConfig } from 'app-config'


const Release = ({ children }) => {

  // const navigate = useNavigate()
  const config = getAppConfig()
  const key = `${config.app.store}/release`
  const currentRelease = localStorage.getItem(key)

  if ( ! currentRelease || currentRelease < config.build.release) {
    localStorage.setItem(key, config.build.release)
    // navigate('/logout')
    return null
  }

  return (
    <>
      {children}
    </>
  )
}

Release.propTypes = {
  children: PropTypes.element,
}

export default Release
